import request from './request'

export function getList(params) {
  return request({
    url: '/materialFile/getList',
    method: 'get',
    params
  })
}

export function deleteFile(data) {
  return request({
    url: '/materialFile/remove',
    method: 'post',
    data
  })
}

export function getDeconstructBySignature(data) {
  return request({
    url: '/materialStore/getDeconstructBySignature',
    method: 'post',
    data
  })
}

export function lockStoryAnalyse(data) {
  return request({
    url: '/materialStore/lockStoryAnalyse',
    method: 'post',
    data
  })
}

export function getButtonPermission() {
  return request({
    url: '/materialStore/getButtonPermission',
    method: 'post'
  })
}

/**
 * 重新分析素材
 * @see {@link https://apifox.com/apidoc/shared-f2c528ed-84c7-47cd-811d-66dbdad7f967/api-226505825}
 */
export function reanalyseMaterial(data) {
  return request({
    url: '/materialStore/reanalyseMaterial',
    method: 'post',
    data
  })
}
